/** The map's base layer: relief (the XD's default), the light gray style, or satellite. */
export const BASE_MAPS = ['terrain', 'light', 'satellite'] as const;
export type BaseMap = typeof BASE_MAPS[number];

const DEFAULT_BASE_MAP: BaseMap = 'terrain';
const STORAGE_KEY = 'baseMap';

/** The viewer's last choice, kept across pages; the default when there is none or storage is blocked. */
export const readBaseMap = (): BaseMap => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return BASE_MAPS.find(baseMap => baseMap === stored) || DEFAULT_BASE_MAP;
  } catch (error) {
    return DEFAULT_BASE_MAP;
  }
};

export const saveBaseMap = (baseMap: BaseMap): void => {
  try {
    localStorage.setItem(STORAGE_KEY, baseMap);
  } catch (error) {
    // Blocked storage (private mode): the choice lasts until the page is left.
  }
};
